const IconStar = (): JSX.Element => {
  return (
    <>
      <path
        d="M9.64893 3.62505C9.94828 2.70374 11.2517 2.70374 11.551 3.62505L13.1753 8.62398C13.3092 9.036 13.6931 9.31496 14.1263 9.31496H19.3825C20.3513 9.31496 20.754 10.5546 19.9703 11.124L15.718 14.2135C15.3675 14.4681 15.2208 14.9195 15.3547 15.3315L16.979 20.3305C17.2783 21.2518 16.2238 22.0179 15.4401 21.4485L11.1878 18.359C10.8373 18.1043 10.3627 18.1043 10.0122 18.359L5.75985 21.4485C4.97614 22.0179 3.92166 21.2518 4.22101 20.3305L5.84526 15.3315C5.97914 14.9195 5.83248 14.4681 5.48199 14.2135L1.22965 11.124C0.445932 10.5546 0.848709 9.31496 1.81743 9.31496H7.07362C7.50685 9.31496 7.8908 9.036 8.02468 8.62398L9.64893 3.62505Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconStar;
